import { render } from "./IconRefresh.vue?vue&type=template&id=c9d00c6e"
import script from "./IconRefresh.vue?vue&type=script&lang=js"
export * from "./IconRefresh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__